import { MonitoringDataset } from '../Components/QuestionnaireResults/QuestionnaireResults';
import { IHealthData } from '../../HealthData/Hooks/useHealthData';
import apiClient from '../../../Services/ApiClient';
import {
	groupDataByTitle,
	modifyQuestionnaireResultChartToHealthData,
} from '../../utils/dataModifications';
import moment, { Moment } from 'moment';
import { getDateAsIso } from '../../../Helpers/date.helper';

export default function useQuestionnaireResultTable() {
	const getData = async (
		patientId: string,
		questionnaireCode: string,
		from?: Moment,
		to?: Moment,
	) => {
		const dateFrom = from?.toISOString() ?? getDateAsIso('2022-01-01');
		const dateTo = to?.toISOString() ?? getDateAsIso();
		const data = await apiClient.get(
			'/user/' +
				patientId +
				'/questionnaire/result/chart?from=' +
				dateFrom +
				'&to=' +
				dateTo +
				'&questionnaireCode=' +
				questionnaireCode,
		);
		return data;
	};

	const getDataAsHealthData = async ({
		patientId,
		questionnaireCode,
		questionnaireName,
		t,
		from,
		to,
		groupByTitle = false,
		roundValuesTo,
	}: {
		patientId: string;
		questionnaireCode: string;
		questionnaireName: string | null;
		t: (key: string, params?: any) => string | undefined;
		from?: Moment;
		to?: Moment;
		groupByTitle?: boolean;
		roundValuesTo?: number;
	}) => {
		return modifyQuestionnaireResultChartToHealthData(
			groupByTitle
				? groupDataByTitle(await getData(patientId, questionnaireCode))
				: await getData(patientId, questionnaireCode),
			questionnaireCode,
			questionnaireName,
			t,
			roundValuesTo,
		);
	};

	const filterKeys = (data: MonitoringDataset, keys: string[]) => {
		const filteredData: IHealthData[] = [];
		data.results.map(item => {
			if (keys.some(k => k === item.key)) {
				filteredData.push(item);
			}
		});
		return { results: filteredData } as MonitoringDataset;
	};

	return { getDataAsHealthData, getData, filterKeys };
}
